import { render, staticRenderFns } from "./PageUsages.vue?vue&type=template&id=bd04fb2a"
import script from "./PageUsages.vue?vue&type=script&lang=js"
export * from "./PageUsages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports